import Icon from '../components/Icon.vue'

Icon.register({
  outdent: {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M0 84V44C0 35.2 7.2 28 16 28H432C440.8 28 448 35.2 448 44V84C448 92.8 440.8 100 432 100H16C7.2 100 0 92.8 0 84zM208 228H432C440.8 228 448 220.8 448 212V172C448 163.2 440.8 156 432 156H208C199.2 156 192 163.2 192 172V212C192 220.8 199.2 228 208 228zM16 484H432C440.8 484 448 476.8 448 468V428C448 419.2 440.8 412 432 412H16C7.2 412 0 419.2 0 428V468C0 476.8 7.2 484 16 484zM208 356H432C440.8 356 448 348.8 448 340V300C448 291.2 440.8 284 432 284H208C199.2 284 192 291.2 192 300V340C192 348.8 199.2 356 208 356zM4.7 267.3L100.7 363.3C110.7 373.3 128 366.2 128 352V160C128 145.7 110.7 138.7 100.7 148.7L4.7 244.7C-1.6 250.9-1.6 261.1 4.7 267.3z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/outdent.js
// module id = oDyj
// module chunks = 144